module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-3.627329e6.png";